import request from '@/request'
import handler from '@/utils/responseHandler'

export default {
  /**
   * 获取用户地址列表
   */
  '102135': (data = {}) => {
    data.pid = 102135

    return request.ticket({
      url: '/gateway/api/user',
      data,
      auth: 'yes',
      sidFields: ['uid', 'pid']
    }).then(handler.resBdData)
  },
  /**
   * 添加新用户地址
   */
  '102136': (data = {}) => {
    data.pid = 102136

    return request.ticket({
      url: '/gateway/api/user',
      data,
      auth: 'yes',
      sidFields: ['uid', 'pid', 'operation']
    }).then(handler.resBdData)
  }
}



// WEBPACK FOOTER //
// ./src/api/userAddress.js